module.exports = __webpack_public_path__ + "img/shop-gem.754233db.png";